import api from "utils/api";

const PAYMENT_API_PATH = "/buccl_payment/api/v1";

// 강습 기록 월별 통계 조회
export const getLessonMonthlyStats = async (year, month) => {
    try {
        const res = await api.get(`${PAYMENT_API_PATH}/records/monthly_stats/`, {
            params: { year, month },
        });
        return res.data;
    } catch (error) {
        console.error("[instructorStats] getLessonMonthlyStats 실패:", error);
        return null;
    }
};

// 연습반 기록 월별 통계 조회
export const getPracticeMonthlyStats = async (year, month) => {
    try {
        const res = await api.get(
            `${PAYMENT_API_PATH}/practice-records/monthly_stats/`,
            {
                params: { year, month },
            }
        );
        return res.data;
    } catch (error) {
        console.error("[instructorStats] getPracticeMonthlyStats 실패:", error);
        return null;
    }
};
